<template>
  <div id="app">
      <div class="maincon">
        <div class="tab-tilte">
          <p @click="cur=0" :class="{active:cur==0}" style="margin-left: 0;cursor: pointer;">&nbsp;&nbsp;&nbsp;任务&nbsp;&nbsp;&nbsp; </p>
          <p @click="cur=1" :class="{active:cur==1}" style="margin-left: 0;cursor: pointer;">线下任务</p>
          <p @click="cur=2" :class="{active:cur==2}" style="cursor: pointer;">&nbsp;&nbsp; &nbsp;员工&nbsp;&nbsp; &nbsp;</p>
        </div>
        <div class="tab-content">
          <traininfo v-show="cur==0"></traininfo>
          <trainoutinfo v-show="cur==1"></trainoutinfo>
          <traincompanyee v-show="cur==2"></traincompanyee>
        </div>

</div>
  </div>

</template>

<script>
  import traininfo from './train_info.vue';
  import trainoutinfo from './train_out_info.vue';
  import traincompanyee from './train_companyee.vue';


  export default {
    name: 'App',
    data() {
      return {
        cur: 0,
      }
    },
    components: {
      traininfo: traininfo,
      trainoutinfo: trainoutinfo,
      traincompanyee: traincompanyee
    },
      methods: {

      },

  }
</script>

<style scoped>


  .maincon {
   padding: 20px;
   height: calc(100vh - 40px);
   overflow-y: auto;
  }

  .tab-tilte {
    height: 41px;
  }

  .tab-tilte>p {
    float: left;
    margin: 0 5px;
    padding: 10px 15px;
    background-color: white;
    border: 1px solid #DCDCDC;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    font-size: 15px;
  }

  .active {

    border-bottom: 1px solid white !important;
  }

  .tab-content {
    background-color: white;
    border: 1px solid #DCDCDC;
    min-height: calc(100% - 83px);
    border-radius: 0px 5px 5px 5px;
    padding: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/view/company/census/train/train.vue